<template lang="pug">
div
    div(v-html="getCss")
    div.showModel(v-if="showModel === true")
        div Model Data
            div(v-html="prettyJson()")            
    template(v-for="itemMain in schema")
        template(v-for="item, index in itemMain")
            template(v-if="item.type === 'breakLine'")
                br(
                    ref="breakLine" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'button'")
                buttonForm(
                    ref="button"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )   
            template(v-if="item.type === 'buttonGroup'")
                buttonGroup(
                    ref="buttonGroup"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item"
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                ) 
            template(v-if="item.type === 'checkbox'")      
                checkbox(
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    ref="checkbox"
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'checklist'")  
                checklist(
                    ref="checklist"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    @change="onChangeEvent(index, 'single', 0)"
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'currentFiles'")
                currentFile(
                    ref="currentFiles"
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                ) 
            template(v-if="item.type === 'datetimepicker'")                
                datetimepicker(
                    ref="datetimepicker"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )  
            template(v-if="item.type === 'doubleInput'")
                doubleInput(
                    ref="formInput"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'doubleInputVFor'")
                doubleInputVFor(
                    ref="formInput"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index"
                    v-if="visibility(index, 'single', 0)" 
                )      
            template(v-if="item.type === 'fileUpload'")
                fileUpload(
                    ref="fileUploadField"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :formBox="formBox"
                    :fullSchema="schema"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )      
            template(v-if="item.type === 'fileUploadHint'")
                fileUploadHint(
                    ref="fileUploadHint"
                    :disabled="disability(index, 'single', 0)"
                    :formBox="formBox"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'fileUploadSingle'")
                fileUploadSingle(
                    ref="fileUploadSingle"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    @validateChild="validateIt" 
                    v-if="visibility(index, 'single', 0)" 
                )      
            template(v-if="item.type === 'freeText'")  
                freeText(
                    ref="freeText"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model"
                    :schema="item"
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'furtherEmail'")                
                furtherEmail(
                    ref="furtherEmail"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'furtherJobs'")
                furtherJobs(
                    ref="furtherJobs"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )            
            template(v-if="item.type === 'fVisitor'")
                fVisitor(
                    ref="fVisitor"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )   
            template(v-if="item.type === 'groupFunction'")
                .vueFormFieldMain
                    div.myGroupfunction(
                        v-if="visibility(index, 'single', 0)" 
                        :class="schema.class"
                    )
                        label(v-if="item.label && item.label.length > 0" v-html="item.label")
                        div(:class="item.direction === 'horizontical' ? 'row': ''")
                            template(v-for="groupItem, groupIndex in item.elements")
                                div(:class="item.direction === 'horizontical' ? `col-${groupItem.size}` : ''")
                                    template(v-if="groupItem.type === 'select'")
                                        selectForm(
                                            ref="groupSelect"
                                            :model="model" 
                                            :schema="groupItem" 
                                            :schemaId="groupIndex" 
                                            :id="setId()" 
                                            :disabled="disability(index, 'group', groupIndex)"
                                            @change="onChangeEvent(index, 'group', groupIndex)"
                                            @buttonClickParent="buttonClickHandler"
                                            @validateChild="validateIt"  
                                            v-if="visibility(index, 'group', groupIndex)" 
                                        )  
                                    template(v-if="groupItem.type === 'input'")      
                                        inputForm(
                                            ref="groupInput"
                                            :fullSchema="schema"
                                            :id="setId()" 
                                            :model="model" 
                                            :schema="groupItem" 
                                            :schemaId="groupIndex" 
                                            :disabled="disability(index, 'group', groupIndex)"
                                            :hinted="hintability(index, 'group', groupIndex)"
                                            @buttonClickParent="groupItem.buttonClickHandler"
                                            @validateChild="validateIt" 
                                            v-if="visibility(index, 'group', groupIndex)" 
                                        )
            template(v-if="item.type === 'headLine'")
                headLine(
                    ref="headLine"
                    :disabled="disability(index, 'single', 0)"
                    :id="setId()" 
                    :model="model",
                    :schema="item"
                    :schemaId="index" 
                    :hinted="hintability(index,'single', 0)"
                    v-if="visibility(index, 'single', 0)" 
                )          
            template(v-if="item.type === 'horizonticalLine'")
                hr(
                    ref="horizonticalLine" 
                    :class="item.class"
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'input'")                
                inputForm(
                    ref="formInput"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'inputFEmail'")                
                inputFEmail(
                    ref="formInputFEmail"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'preview'")
                previewForm(
                    ref="preview"
                    :hinted="hintability(index,'single', 0)"
                    :disabled="disability(index, 'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'radio'")                
                radioForm(
                    ref="radio"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    @change="onChangeEvent(index, 'single', 0)"
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'sectionJob'")
                sectionJob(
                    ref="sectionJob"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'sectorProduct'")
                sectorProduct(
                    ref="sectorProduct"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'select'")
                selectForm(
                    ref="select"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    :vueModel="vueModel"
                    @buttonClickParent="buttonClickHandler"
                    @buttonFunctionParent="buttonFunctionParent"
                    @change="onChangeEvent(index, 'single', 0)"
                    v-if="visibility(index, 'single', 0)" 
                )    
            template(v-if="item.type === 'switch'")
                switchForm(
                    ref="switch"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    @validateChild="validateIt" 
                    v-if="visibility(index, 'single', 0)" 
                )
            template(v-if="item.type === 'webServiceData'")
                webServiceData(
                    ref="swbWebsiteTitle"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    @validateChild="validateIt" 
                    v-if="visibility(index, 'single', 0)" 
                ) 
            template(v-if="item.type === 'textarea'")
                textareaForm(
                    ref="textarea"
                    :disabled="disability(index, 'single', 0)"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    @validateChild="validateIt" 
                    v-if="visibility(index, 'single', 0)" 
                )      
            template(v-if="item.type === 'treeSelect'")
                treeSelect(
                    ref="treeSelect"
                    :disabled="disability(index, 'single', 0)"
                    :fullSchema="schema"
                    :hinted="hintability(index,'single', 0)"
                    :id="setId()" 
                    :model="model" 
                    :schema="item" 
                    :schemaId="index" 
                    v-if="visibility(index, 'single', 0)" 
                )
</template>
<script>
/* jshint esversion: 6 */
import { ref, toRef, provide, inject} from 'vue';
import button from './fields/button.vue';
import buttonGroup from './fields/buttonGroup.vue'; 
import checkList from './fields/checkList.vue';
import checkbox from './fields/checkbox.vue';
import currentFile from './fields/currentFiles.vue';
import datetimepicker from './fields/datetimepicker.vue';
import doubleInput from './fields/doubleInput.vue';
import doubleInputVFor from './fields/doubleInputVFor.vue';
import fVisitor from './fields/fVisitor.vue';
import fileUpload from './fields/fileUpload.vue';
import fileUploadHint from './fields/fileUploadHint.vue';
import fileUploadSingle from './fields/fileUploadSingle.vue';
import freeText from './fields/freeText.vue';
import furtherEmail from './fields/furtherEmail.vue';
import furtherJobs from './fields/furtherJobs.vue';
import headline from './fields/headline.vue';
import inputFEmail from './fields/inputFEmail.vue';
import inputForm from './fields/input.vue';
import preview from './fields/preview.vue';
import radioForm from './fields/radio.vue';
import sectionJob from './fields/sectionJob.vue';
import sectorProduct from './fields/sectorProduct.vue';
import selectForm from './fields/select.vue';
import switchForm from './fields/switch.vue';
import textarea from './fields/textarea.vue';
import treeSelect from './fields/treeSelect.vue';
import webServiceData from './fields/webServiceData.vue';

import { isFunction, isNil} from 'lodash';

export default {
    name: 'VueForm',
    components: {
        'buttonForm': button,
        'buttonGroup': buttonGroup,
        'checkbox': checkbox,
        'checklist': checkList,
        'currentFile': currentFile,
        'datetimepicker': datetimepicker,
        'doubleInput': doubleInput,
        'doubleInputVFor': doubleInputVFor,
        'fVisitor': fVisitor,
        'fileUpload' : fileUpload,
        'fileUploadHint': fileUploadHint,
        'fileUploadSingle': fileUploadSingle,
        'freeText': freeText,
        'furtherEmail': furtherEmail,
        'furtherJobs': furtherJobs,
        'headLine': headline,
        'inputFEmail': inputFEmail,
        'inputForm' : inputForm,
        'previewForm': preview,
        'radioForm' : radioForm,
        'sectionJob': sectionJob,
        'sectorProduct': sectorProduct,
        'selectForm' : selectForm,
        'switchForm': switchForm,
        'textareaForm': textarea,
        'treeSelect': treeSelect,
        'webServiceData': webServiceData,
    },
    props: {
        'formBox': { type: [Object], default: function() { return {};} },
        'formSmallSize' : {type: String, defaut: ''},
        'hintColor': {type: String, defaut: ''},
        'hintFontSize':  {type: String, defaut: ''},
        'hintFontStyle': {type: String, defaut: ''},
        'labelRed' : {type: String, defaut: ''},
        'model': { type: [Object], default: function() { return {};} },  
        'redAst' : {type: String, defaut: ''},
        'schema': { type: [Object], default: function() { return {};} }, 
        'showModel': {type: Boolean},
        'validators': { type: [Object], default: function() { return {};} }, 
    }, 
    emits: ['openFunc'],    
    setup(props, ctx) {
        const errors = ref([]);
        const vueModel = toRef(props);

        function buttonClickHandler(fromChild) {
            let field = props.schema.fields[fromChild.id];
            if(isFunction(field.buttons.onclick)) return field.buttons.onclick.call(this, props.model, field, this);
            if(isNil(field.buttons.onclick)) return;
            return;
        }
        function buttonClickSubmitHandler(fromChild) {
            let field = props.schema.fields[fromChild.id].buttons[fromChild.buttonIndex];
            if(isFunction(field.onclick)) return field.onclick.call(this, props.model, field, this);
            if(isNil(field.onclick)) return;
            return;
        }
        function buttonFunctionParent(fromChild) {
            ctx.emit('openFunc', fromChild);
        }            
        function disability(id, type, groupId) {
            let field = this.getFieldId(id, type, groupId);
            if(isFunction(field.disabled)) {
                return field.disabled.call(this, props.model, field, this);
            }
            if(isNil(field.disabled)) return false;
            return field.disabled;
        }
        function getFieldId(id, type, groupId) {
            switch(type) {
                case 'single':
                    return props.schema.fields[id];
                case 'group':
                    return props.schema.fields[id].elements[groupId];
            }
        }
        function hintability(id, type, groupId) {
            let field = this.getFieldId(id, type, groupId);
            if(isFunction(field.hinted)) {
                return field.hinted.call(this, props.model, field, this);
            }
            if(isNil(field.hinted)) {
                return '';
            }
            return field.hinted;
        }
        function onChangeEvent(id, type, groupId) {
            let field = this.getFieldId(id, type, groupId);
            if(isFunction(field.onChange)) return field.onChange.call(this, props.model, field, this);
            if(isNil(field.onChange)) return;
            return;
        }
        function onClickEvent(id, type, groupId) {
            let field = this.getFieldId(id, type, groupId);
            if(isFunction(field.onclick)) return field.onclick.call(this, props.model, field, this);
            if(isNil(field.onclick)) return;
            return;
        }
        function prettyJson() {
            let jsonArr = '';
            let obj = props.model;
            let keys = Object.keys(obj).sort().reduce(function (result, key) {
                result[key] = obj[key];
                return result;
            }, {});

            Object.entries(keys).forEach(value => {
                if (value[0] !== 'content') {
                    jsonArr += `${value[0]} : ${value[1]} <br>`;
                }
            });
            return jsonArr;
        }
        function setId() {
            let formId = _.uniqueId();
            return `formField${formId}`;
        }
        function validateIt(fromChild) {
            if (fromChild.validator) {
                fromChild.validator.forEach(value => {
                    if (value) {
                        if (isFunction(props.validators[value])) {
                            let error;
                            error = props.validators[value](props.model[fromChild.model], props.schema.fields[fromChild.id], props.model);
                            if (error.length > 0) {
                                props.schema.fields[fromChild.id].errorText = error;
                                props.schema.fields[fromChild.id].errorShow = true;
                            } else {
                                props.schema.fields[fromChild.id].errorText = [];
                                props.schema.fields[fromChild.id].errorShow = false;
                            }
                        } else {
                            console.warn("vueForm - validateAll - no function set", value);
                        }
                    } else {
                        console.warn("vueForm - validateIt - no value set", value);
                    }
                });
            }
        }
        function validateAll() {
            errors.value = [];
            Object.values(props.schema.fields).forEach((value, key) => {
                var isVisible = false;
                var isDisable = false;
             
                if (value.visible) {
                    if (isFunction(value.visible)) {
                        if(value.visible.call(this, props.model, value, this === true)) {
                            isVisible = true;
                        }
                    } else {
                        isVisible = value.visible;
                    }
                } else {
                    isVisible = true;
                }
               
                if (value.disabled) {
                    if (isFunction(value.disabled)) {
                        if(value.disabled.call(this, props.model, value, this === true)) {
                            isDisable = true;
                        }
                    } else {
                        isDisable = value.disabled;
                    }
                } else {
                    isDisable = false;
                }

                if (
                    ((value.required && value.required === true) || (value.checkIt && value.checkIt === true)) && 
                    (isVisible === true) && (isDisable === false)
                ) {
                    if (value.validator) {
                        value.validator.forEach(value2 => {
                            if (value2) {
                                if (isFunction(props.validators[value2])) {
                                    let error;
                                    error = props.validators[value2](props.model[value.model], props.schema.fields[key], props.model);
                                    if (error.length > 0) {
                                        errors.value.push(value.model);
                                        props.schema.fields[key].errorText = error;
                                        props.schema.fields[key].errorShow = true;
                                    } else {
                                        props.schema.fields[key].errorText = [];
                                        props.schema.fields[key].errorShow = false;
                                    }
                                } else {
                                    console.warn("vueForm - validateAll - no function set", value2);
                                }
                            } else {
                                console.warn("vueForm - validateAll - no value set", value2);
                            }
                        });
                    }
                }
                
            });

            if (errors.value.length === 0) {
                return true;
            } else {
                return false;
            }
        }
        function visibility(id, type, groupId) {
            let field = getFieldId(id, type, groupId);
            if (isFunction(field.visible)) {
                 return field.visible.call(this, props.model, field, this);
            }
            if (isNil(field.visible)) return true;
            return field.visible;
        }


        const getCss = ref(`<style>
            .redAst{color:${props.redAst}}
            .labelred{color:${props.labelRed}}
            .vueFormSmall{font-size:${props.formSmallSize}pt}
            .hint {font-size: ${props.hintFontSize}pt;color:${props.hintColor};font-style:${props.hintFontStyle};}
            .showModel{background: white;padding: 5vw;}
        </style>`);

        provide('buttonClickParent', buttonClickHandler);
        provide('buttonClickSubmitHandler', buttonClickSubmitHandler);
        provide('buttonFunctionParent', buttonFunctionParent);
        provide('validateChild', validateIt);
        return {
            buttonClickHandler,
            buttonClickSubmitHandler,
            buttonFunctionParent,
            disability,
            errors,
            getCss,
            getFieldId,
            hintability,
            onChangeEvent,
            onClickEvent,
            prettyJson,
            setId,
            validateAll,
            validateIt,
            visibility,
            vueModel,
        }
    }
};
</script>